export const whitelist = [
  "phong.nt2@amanotes.com",
  "vu.tp@amanotes.com",
  "tan.vq@amanotes.com",
  "hoang.nk@amanotes.com",
  "dung.nq2@amanotes.com",
];
